var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.tpl==1)?_c('Home'):_vm._e(),(_vm.tpl==2)?_c('Home2'):_vm._e(),(_vm.tpl==3)?_c('Home3'):_vm._e(),(_vm.tpl==4)?_c('Home4'):_vm._e(),(_vm.tpl==5)?_c('Home5'):_vm._e(),(_vm.tpl==6)?_c('Home6'):_vm._e(),(_vm.tpl==7)?_c('Home7'):_vm._e(),(_vm.tpl==8)?_c('Home8'):_vm._e(),(_vm.tpl==9)?_c('Home4'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }